/**
 * SkyChart - Point d'entrée principal
 */
import { SkyChart } from './core/SkyChart.js';

// Initialisation au chargement de la page
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".sky-chart").forEach(function (element) {
        const scriptElement = element.querySelector('script');
        if (scriptElement) {
            try {
                const data = JSON.parse(scriptElement.textContent);
                const canvas = element.querySelector('canvas');
                if (canvas) {
                    new SkyChart(canvas, data);
                }
            } catch (error) {
                console.error("Erreur lors de l'initialisation du SkyChart:", error);
            }
        }
    });
});

// Exporter la classe principale pour permettre son utilisation explicite
export { SkyChart };